import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const services = [
  {
    id: 1,
    title: 'Candlelight Pathway',
    image: '/images/candel.webp',
    alt: 'Candlelight Pathway'
  },
  {
    id: 2,
    title: 'Venue Decoration',
    image: '/images/image2.png',
    alt: 'Venue Decoration'
  },
  {
    id: 3,
    title: 'Personalized Gift',
    image: '/images/gift.jpg',
    alt: 'Personalized Gift'
  },
  {
    id: 4,
    title: 'LED Name Display',
    image: '/gallery/image2.JPG',
    alt: 'LED Name Display'
  },
  {
    id: 5,
    title: 'Floral Bouquet',
    image: '/images/flower.webp',
    alt: 'Floral Bouquet'
  },
  {
    id: 6,
    title: 'Customized Cake',
    image: '/gallery/chocolate.jpg',
    alt: 'Customized Cake'
  }
];

const ServicesSlider = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-semibold text-center mb-12">
          Services We Provide
        </h2>
        
        <div className="relative">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={{
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next',
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            className="mySwiper"
          >
            {services.map((service) => (
              <SwiperSlide key={service.id}>
                <div className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 bg-white">
                  <img
                    src={service.image}
                    alt={service.alt}
                    className="w-full h-52 object-cover transform hover:scale-105 transition-all duration-300"
                  />
                  <h4 className="font-medium text-center py-4 text-lg">
                    {service.title}
                  </h4>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button className="swiper-button-prev absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 z-10 bg-dark text-white rounded-full p-3 shadow-lg hover:bg-primary-600 transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          
          <button className="swiper-button-next absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 z-10 bg-dark text-white rounded-full p-3 shadow-lg hover:bg-primary-600 transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSlider; 